import { Component } from '@angular/core';
import { InvoiceService } from '../../../../Services/Invoice/invoice.service';
import { AuthService } from '../../../../Services/auth.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-sales-history',
  imports: [],
  templateUrl: './sales-history.component.html',
  styleUrl: './sales-history.component.css'
})
export class SalesHistoryComponent {

  invoiceData : any;

  constructor(private invoiceService:InvoiceService,private authService:AuthService){}

  ngOnInit(){
    this.getInvoiceDetails();
  }

  getInvoiceDetails() {
    let params = new HttpParams();

    this.invoiceService.getInvoices(params).subscribe((response: any) => {
      const allInvoices = response;

      const userId = this.authService.getUserId();

      if (this.authService.getUserRole() === 'Staff') {
        this.invoiceData = allInvoices.filter((inv: any) =>
          inv.in_user_id == userId
        );
      } else {
        this.invoiceData = allInvoices;
      }

      console.log("Filtered invoice data is", this.invoiceData);
    });
  }
}
